import { render } from "./P075.vue?vue&type=template&id=6ac7c1fa&scoped=true"
import script from "./P075.vue?vue&type=script&lang=js"
export * from "./P075.vue?vue&type=script&lang=js"

import "./P075.vue?vue&type=style&index=0&id=6ac7c1fa&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac7c1fa"]])

export default __exports__